import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './sanolivar-style.css';

import Header from './components/Header';
import Footer from './components/Footer';
import Form from './components/Form.jsx';
import Name from './utils/Name.js';
import Chatbot from './components/Chatbot.jsx';

const assetsInnov = './assets/images/innovacion/';

import { root } from './utils/Path.js';

createRoot(document.getElementById('innovacion')).render(
    <StrictMode>
        <Header active={"Innovación & Servicios"} />
        {/* BANNER */}
        <section className="banner">
            <div className="background">
                <video loading="lazy" autoPlay muted loop src="./assets/videos/banner-innovacion2.mp4" aria-label='video de fondo, grafos y graficas.'></video>
            </div>
            <div>
                <h1>Innovación y Servicios</h1>
                <p className='stretch'>Entendiendo las demandas del mundo contemporáneo, en Sanolivar hemos desarrollado cuatro dimensiones de servicios que amplifican y enriquecen nuestra oferta de valor: Inteligencia Artificial, IoT, Servicios de Localización y Servicios Profesionales.</p>
            </div>
        </section>
        {/* SUBSECTIONS */}
        <section className="compressed" data-aos="fade-up">
            <h2>Nuestras Soluciones</h2>
            <div className="exposer">
                <div className="card-expo flow expanded dark">
                    <img loading="lazy" src={`${assetsInnov}ia.webp`} alt='Letras AI en 3d' aria-label='Letras AI en 3d' title='Letras AI en 3d' />
                    <div>
                        <div>
                            <h3>Inteligencia Artificial</h3>
                            <p>Desarrollamos soluciones de IA que transforman procesos, mejoran la eficiencia y generan resultados reales. Desde asistentes digitales hasta análisis predictivos, nuestra tecnología está diseñada para adaptarse a las necesidades de tu industria. Innovación y precisión en cada paso, llevando tu negocio más allá de lo imaginable.</p>
                        </div>
                        <button><a role='link' title="Ir a servicios de IA" href={`${root}servicios-ia.html`}></a>Ver Más</button>
                    </div>
                </div>
                <div className="card-expo flow expanded dark">
                    <img loading="lazy" src={`${assetsInnov}iot.webp`} alt='Robot con inteligencia artificial' aria-label='Robot con inteligencia artificial' title='Robot con inteligencia artificial' />
                    <div>
                        <div>
                            <h3>Internet de las Cosas - IoT</h3>
                            <p>En Sanolivar, creemos que el futuro de la tecnología está en la conexión inteligente de dispositivos, datos y personas. El Internet de las Cosas (IoT) es la clave para transformar industrias, mejorar la eficiencia operativa y ofrecer soluciones innovadoras que impulsen un mundo más interconectado.</p>
                        </div>
                        <button><a role='link' title="Ir a servicios de IoT" href={`${root}servicios-iot.html`}></a>Ver Más</button>
                    </div>
                </div>
                <div className="card-expo flow expanded dark">
                    <img loading="lazy" src={`${assetsInnov}location-services.webp`} alt='Persona usando servicios de localización en su celular.' aria-label='Persona usando servicios de localización en su celular.' title='Persona usando servicios de localización en su celular.' />
                    <div>
                        <div>
                            <h3>Location Services</h3>
                            <p>Optimizamos la gestión de ubicaciones mediante soluciones avanzadas de geolocalización. Implementamos tecnologías de rastreo en tiempo real para mejorar la eficiencia operativa en el sector agrícola e industrial. Nuestras soluciones permiten monitorear activos, gestionar flotas y optimizar la distribución de recursos con precisión. Con Sanolivar, toma decisiones estratégicas basadas en datos geoespaciales confiables.</p>
                        </div>
                        <button><a role='link' title="Ir a servicios de localización" href={`${root}servicios-locationservices.html`}></a>Ver Más</button>
                    </div>
                </div>
            </div>
        </section>
        {/* SERVICIOS DE GESTION */}
        <section className='compressed' data-aos="fade-up">
            <h2>Nuestros Servicios</h2>
            <div className="exposer inner stretch" data-aos="fade-left">
                <div className="card-expo expanded dark">
                    <img data-aos="fade-right" loading="lazy" src={`${assetsInnov}services.webp`} alt='Personal de atención al cliente' aria-label='Personal de atención al cliente' title='Personal de atención al cliente' />
                    <div data-aos="fade-left">
                        <div>
                            <h3>Servicios Profesionales - Gestión, Soporte y Adminsitración</h3>
                            <p>En {Name}, entendemos que la gestión eficaz y el soporte técnico de sus operaciones son esenciales para mantener su negocio en movimiento. Nuestros Servicios Profesionales están diseñados para ofrecer soluciones de gestión, soporte y administración que optimizan su infraestructura y aseguran la continuidad operativa.</p>
                        </div>
                        <button><a role='link' title="Ir a servicios de gestión" href={`${root}servicios-gestion.html`}></a>Ver Más</button>
                    </div>
                </div>
            </div>
        </section>
        {/* CONTACTO */}
        <Form
            title={'Contáctanos y encontremos juntos una solución'}
            content={'Complete el formulario a continuación para obtener más información sobre nuestros servicios innovadores y profesionales.'}
            img={{ src: `${assetsInnov}contacto.webp`, alt: 'Hombre usando un computador' }}
            form={[
                {
                    label: 'Nombre contacto',
                    type: 'text',
                    id: 'nombre',
                    placeholder: 'Ingrese su nombre aquí'
                },
                {
                    label: 'Correo electrónico',
                    type: 'email',
                    id: 'email',
                    placeholder: 'Ingrese su correo aquí'
                },
                {
                    label: 'Mensaje',
                    type: 'textarea',
                    id: 'mensaje',
                    placeholder: 'Déjanos un mensaje aquí'
                },
                {
                    label: 'Enviar Mensaje',
                    type: 'submit',
                    id: 'submit',
                }
            ]}
            redirect={`${root}innovacion.html`}
        />
        <Footer />
        <Chatbot />
    </StrictMode>
)